angular.module('impactx.help').directive('ixHelp', function () {
    return {
        restrict: 'E',
        controller: 'HelpCtrl',
        controllerAs: 'helpCtrl',
        templateUrl: 'modules/help/templates/help.dialog.html'
    }
});